import React, { useState } from "react";
import { BsPencil, BsTrash } from "react-icons/bs";
import { FaCircle, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AddRoleModal } from "./AddRoleModal";
import { EditRoleModal } from "./EditRoleModal";
import { RolePermissionsModal } from "./RolePermissionsModal";
import { FiEdit, FiEdit3 } from "react-icons/fi";

const Roles = () => {
  const [buttonType, setButtonType] = useState("roles");
  const [isAddModalOpen, setAddRoleModalOpen] = useState(false);
  const [isEditModalOpen, setEditRoleModalOpen] = useState(false);
  const [isViewPermissionsModalOpen, setViewPermissionsModalOpen] =
    useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  // Sample data with permissions added
  const rolesData = [
    {
      role: "Admin",
      description: "Full system access with all permissions",

      roleType: "System",
      status: "Active",
      permissions: ["full-access-admin", "full-access-super_admin"],
    },
    {
      role: "Teacher",
      description: "Access to student management and grading",
      roleType: "Academic",
      status: "Active",
      permissions: ["can-view-student", "can-edit-student"],
    },
    {
      role: "Student",
      description: "Access to learning materials and submissions",

      roleType: "Academic",
      status: "Active",
      permissions: ["can-view-student"],
    },
    {
      role: "Parent",
      description: "View student progress and reports",
      roleType: "Academic",
      status: "Inactive",
      permissions: ["can-view-student"],
    },
    {
      role: "Content Manager",
      description: "Manage learning materials and resources",
      roleType: "Content",
      status: "Active",
      permissions: [
        "can-view-student",
        "can-edit-student",
        "can-view-supervisor",
      ],
    },
  ];

  const handleEditClick = (role) => {
    setSelectedRole(role);
    setEditRoleModalOpen(true);
  };

  const handleViewPermissions = (role) => {
    setSelectedRole(role);
    setViewPermissionsModalOpen(true);
  };

  return (
    <div className="px-6">
      {/* <div className="flex items-center gap-8 mb-12">
        <button
          onClick={() => setButtonType("dashboard")}
          className={`h-[40px] w-[180px] font-medium rounded-lg ${
            buttonType === "dashboard"
              ? "border border-blue-600 bg-gray-100 text-blue-600"
              : "bg-blue-600 text-white"
          } `}
        >
          Dashboard
        </button>
        <Link>
          <button
            onClick={() => {
              setButtonType("allActivities");
            }}
            className={`h-[40px] w-[180px] font-medium rounded-lg ${
              buttonType === "allActivities"
                ? "border border-blue-600 bg-gray-100 text-blue-600"
                : "bg-blue-600 text-white"
            } `}
          >
            All Activities
          </button>
        </Link>

        <Link>
          <button
            onClick={() => setButtonType("emailTemplates")}
            className={`h-[40px] w-[180px] font-medium rounded-lg ${
              buttonType === "emailTemplates"
                ? "border border-blue-600 bg-gray-100 text-blue-600"
                : "bg-blue-600 text-white"
            } `}
          >
            Email Templates
          </button>
        </Link>
        <Link>
          <button
            onClick={() => setButtonType("scheduleActivities")}
            className={`h-[40px] w-[180px] font-medium rounded-lg ${
              buttonType === "scheduleActivities"
                ? "border border-blue-600 bg-gray-100 text-blue-600"
                : "bg-blue-600 text-white"
            } `}
          >
            Schedule Activities
          </button>
        </Link>
        <Link>
          <button
            onClick={() => setButtonType("manageAccess")}
            className={`h-[40px] w-[180px] font-medium rounded-lg ${
              buttonType === "manageAccess"
                ? "border border-blue-600 bg-gray-100 text-blue-600"
                : "bg-blue-600 text-white"
            } `}
          >
            Manage Access
          </button>
        </Link>
      </div> */}
      {/* <div className="flex items-center gap-8 mb-12">
              <Link to={"/admin/users"}>
              <button
                onClick={() => {setButtonType("users");
                  
                }}
                className={`h-[40px] w-[180px] font-medium rounded-lg ${
                  buttonType === "users"
                    ? "border border-[#FF9348] bg-white text-[#FF9348]"
                    : "bg-[#FF9348] text-white"
                } `}
              >
                Users
              </button>
              </Link>
              <Link to={"/admin/roles"}>
                <button
                    onClick={() => {
                      setButtonType("roles");
                    }}
                  className={`h-[40px] w-[180px] font-medium rounded-lg ${
                    buttonType === "roles"
                      ? "border border-[#FF9348] bg-white text-[#FF9348]"
                      : "bg-[#FF9348] text-white"
                  } `}
                >
                 Roles
                </button>
              </Link>
      
              
            </div> */}
      <div className="flex items-center justify-end mb-2 mt-[-100px]">
        <div
          onClick={() => setAddRoleModalOpen(true)}
          className="text-orange-400 border border-orange-400 p-2 rounded-lg hover:bg-orange-100 font-semibold flex items-center gap-2 cursor-pointer"
        >
          <FaPlus className="text-lg text-orange-400" />
          <button>Add role</button>
        </div>
      </div>
      <div className="bg-white border-gray-400 rounded-lg border w-full relative py-2 px-4">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="text-lg font-bold border-b border-gray-400">
              <tr>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Role
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Description
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Role Access
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Role Type
                </th>
                <th className="px-4 py-3 text-left text-gray-700 font-semibold">
                  Status
                </th>
                <th className="px-4 py-3 text-center text-gray-700 font-semibold">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-400">
              {rolesData.map((role, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-3 whitespace-nowrap">{role.role}</td>
                  <td className="px-4 py-3 whitespace-normal max-w-[300px]">
                    {role.description}
                  </td>
                  <td className="px-4 py-3 whitespace-normal flex items-center ">
                    <button
                      onClick={() => handleViewPermissions(role)}
                      className="ml-2 text-blue-600 hover:text-blue-800"
                      title="View Role Permissions"
                    >
                      view
                    </button>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    {role.roleType}
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span
                      className={`inline-flex items-center px-3 py-1 rounded-md text-sm font-medium ${
                        role.status === "Active"
                          ? "bg-green-100 text-green-800"
                          : "bg-red-100 text-red-800"
                      }`}
                    >
                      <FaCircle
                        className={`h-2 w-2 mr-2 ${
                          role.status === "Active"
                            ? "text-green-500"
                            : "text-red-500"
                        }`}
                      />
                      {role.status}
                    </span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap flex justify-center gap-2">
                    <div
                      className=" cursor-pointer flex items-center gap-2 py-1 px-3 text-white hover:bg-blue-600 rounded-md bg-[#539BFF] "
                      onClick={() => handleEditClick(role)}
                      title="Edit Role"
                    >
                       <p>Edit Role</p>
                       <FiEdit3 className="text-white" />
                    </div>
                   
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modals */}
      {isAddModalOpen && (
        <AddRoleModal
          onClose={() => setAddRoleModalOpen(false)}
          isOpen={isAddModalOpen}
        />
      )}

      {isEditModalOpen && selectedRole && (
        <EditRoleModal
          onClose={() => setEditRoleModalOpen(false)}
          isOpen={isEditModalOpen}
          roleData={selectedRole}
        />
      )}

      {isViewPermissionsModalOpen && selectedRole && (
        <RolePermissionsModal
          isOpen={isViewPermissionsModalOpen}
          onClose={() => setViewPermissionsModalOpen(false)}
          initialPermissions={selectedRole.permissions}
          title="View Role Permissions"
          mode="view"
        />
      )}
    </div>
  );
};

export default Roles;
